import { render, staticRenderFns } from "./footerBar.vue?vue&type=template&id=53c20223&scoped=true&"
import script from "./footerBar.vue?vue&type=script&lang=js&"
export * from "./footerBar.vue?vue&type=script&lang=js&"
import style0 from "./footerBar.vue?vue&type=style&index=0&id=53c20223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c20223",
  null
  
)

export default component.exports